__turbopack_context__.v({
  "brandName": "Yk85Uq_brandName",
  "card": "Yk85Uq_card",
  "cardLogo": "Yk85Uq_cardLogo",
  "cardLogoFallback": "Yk85Uq_cardLogoFallback",
  "error": "Yk85Uq_error",
  "field": "Yk85Uq_field",
  "footer": "Yk85Uq_footer",
  "forgot": "Yk85Uq_forgot",
  "hasError": "Yk85Uq_hasError",
  "header": "Yk85Uq_header",
  "headerInner": "Yk85Uq_headerInner",
  "headerLogo": "Yk85Uq_headerLogo",
  "headerLogoFallback": "Yk85Uq_headerLogoFallback",
  "input": "Yk85Uq_input",
  "inputIcon": "Yk85Uq_inputIcon",
  "inputWithToggle": "Yk85Uq_inputWithToggle",
  "inputWrapper": "Yk85Uq_inputWrapper",
  "is-medium": "Yk85Uq_is-medium",
  "is-small": "Yk85Uq_is-small",
  "label": "Yk85Uq_label",
  "main": "Yk85Uq_main",
  "page": "Yk85Uq_page",
  "submit": "Yk85Uq_submit",
  "subtitle": "Yk85Uq_subtitle",
  "title": "Yk85Uq_title",
  "toggleVisibility": "Yk85Uq_toggleVisibility",
  "wrapper": "Yk85Uq_wrapper",
});
